import type { ActionMeta } from '@lokalise/louis';

import type { Option, Value } from '../types';

const createOptionsMap = (options: readonly Option[]) => {
    const optionsMap: { [key: string]: string } = {};

    options.forEach(({ value, label }) => {
        optionsMap[value] = label;
    });

    return optionsMap;
};

export const prepareIncomingValue = (value: Value, options: readonly Option[]): Option[] => {
    const optionsMap = createOptionsMap(options);

    return Object.entries(value)
        .filter(([, val]) => val)
        .map(([key]) => ({ value: key, label: optionsMap[key] }));
};

export const manageRelationshipsBetweenValues = (value: Value, action: ActionMeta<Option>): Value => {
    const newValue = { ...value };

    if (action.action === 'select-option') {
        if (action.option?.value === 'exportAll') {
            newValue.exportGlastReviewed = false;
            newValue.exportGnonfuzzy = false;
            newValue.exportGnonhidden = false;
            newValue.exportGproofread = false;
            newValue.exportGtranslated = false;
            newValue.exportGuntranslated = false;
        } else {
            newValue.exportAll = false;
        }

        if (action.option?.value === 'exportGtranslated') {
            newValue.exportGuntranslated = false;
        }

        if (action.option?.value === 'exportGuntranslated') {
            newValue.exportGtranslated = false;
        }

        if (action.option?.value === 'exportGlastReviewed') {
            newValue.exportGproofread = false;
        }

        if (action.option?.value === 'exportGproofread') {
            newValue.exportGlastReviewed = false;
        }
    }

    const isAnySelected = !!Object.values(newValue).filter((item) => item).length;

    if (!isAnySelected) {
        newValue.exportAll = true;
    }

    return newValue;
};

export const prepareOutgoingValue = (value: readonly Option[], action: ActionMeta<Option>): Value => {
    const valueMap = createOptionsMap(value);

    return manageRelationshipsBetweenValues(
        {
            exportAll: !!valueMap.exportAll,
            exportGlastReviewed: !!valueMap.exportGlastReviewed,
            exportGnonfuzzy: !!valueMap.exportGnonfuzzy,
            exportGnonhidden: !!valueMap.exportGnonhidden,
            exportGproofread: !!valueMap.exportGproofread,
            exportGtranslated: !!valueMap.exportGtranslated,
            exportGuntranslated: !!valueMap.exportGuntranslated,
        },
        action,
    );
};
